import React, { useEffect, useState } from "react";
import { FiEye, FiEyeOff } from "react-icons/fi";
import PageName from "../../components/PageName";
import AccountCard from "../../components/AccountCard";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { getDashboardBalances } from "../../redux/selfService/selfServiceSlice";
import { numberShortener } from "../../utils";
import CopyToClipboard from "../../components/CopyComponent/copy-to-clipboard";
import InactivityTimeoutHOC from "../auth/inactivity-timeout-hoc";
import TimeOutActivityLayout from "../auth/inactivity-timeout-v2";

const Dashboard = () => {
  const { user } = useAppSelector((state) => state.auth);
  const [hideBalances, setHideBalances] = useState(false);
  const { isDashboardLoading, dashboardBalances } = useAppSelector(
    (state) => state?.selfService
  );
  const dispatch = useAppDispatch();

  useEffect(() => {
    const hideBalance = localStorage.getItem("hide-dashboard-balances");
    if (hideBalance) {
      setHideBalances(parseInt(hideBalance) == 1);
    }
  }, []);

  useEffect(() => {
    console.log("user details", user);
    if (user) {
      // @ts-ignore
      dispatch(getDashboardBalances(user.pin));
    }
  }, [user]);

  const stringiNumberfy = (num: string): string => {
    return numberShortener(parseFloat(num.replace(/\,/g, "")), 0);
  };

  return (
    <TimeOutActivityLayout>
    <div>
      <PageName pageName={"Home"} />
      <div className="dashboard-ztem">
        <div className="dashboard-user">
          <div>
            <div className="welcome-text">
              Welcome, {`${user.firstName} ${user.surname}`}
             
              <div className="badges">
                {/* <div className="success-badge">
                  PIN: <strong>{`${user.pin}`}{" "}</strong> | {" "}
                  <strong>{`${user.fund}`}</strong>
                </div> */}

                <CopyToClipboard text={`PIN: ${user.pin} | ${user.fund}`} />

              </div>
            </div>

            {/*<div className="login-details">
                            <span className="font-medium">Last login date: </span>
                            <span>Mar 1, 2023 04:00PM</span>
                        </div>*/}
          </div>
          <div>
            {!hideBalances ? (
              <button
                className="btn btn-outline btn-flat"
                onClick={() => {
                  localStorage.setItem("hide-dashboard-balances", "1");
                  setHideBalances(true);
                }}
              >
                <FiEyeOff className="mr-2" />
                Hide Balance
              </button>
            ) : (
              <button
                className="btn btn-outline btn-flat"
                onClick={() => {
                  localStorage.setItem("hide-dashboard-balances", "0");
                  setHideBalances(false);
                }}
              >
                <FiEye className="mr-2" />
                Show Balance
              </button>
            )}
          </div>
        </div>
        <div className="h1">Retirement Savings Account</div>
        {dashboardBalances && (
          <div className="dashboard-cards">
            <AccountCard
              headText={"Current Value"}
              mainValue={dashboardBalances.currentValue}
              percentageDifference={0}
              hideBalance={hideBalances}
            />
            <AccountCard
              headText={"Growth"}
              mainValue={dashboardBalances.growth}
              percentageDifference={0}
              hideBalance={hideBalances}
            />
            <AccountCard
              headText={"Net Contribution"}
              mainValue={dashboardBalances.netContribution}
              percentageDifference={40}
              hideBalance={hideBalances}
            />
            <AccountCard
              headText={"Total Contribution"}
              mainValue={dashboardBalances.totalContribution}
              percentageDifference={40}
              hideBalance={hideBalances}
            />
            <AccountCard
              headText={"Unit Price"}
              mainValue={dashboardBalances.unitPrice}
              percentageDifference={40}
              hideBalance={hideBalances}
              notACurrency
            />
            <AccountCard
              headText={"Total Units"}
              mainValue={dashboardBalances.totalUnits}
              percentageDifference={40}
              hideBalance={hideBalances}
              notACurrency
            />
          </div>
        )}
        <div className="h1">VC Scheme</div>
        {dashboardBalances && (
          <div className="dashboard-cards">
            <AccountCard
              headText={"Current Value"}
              mainValue={dashboardBalances.vcCurrentValue}
              percentageDifference={0}
              hideBalance={hideBalances}
            />
            <AccountCard
              headText={"Growth"}
              mainValue={dashboardBalances.vcGrowth}
              percentageDifference={0}
              hideBalance={hideBalances}
            />
            <AccountCard
              headText={"Net Contribution"}
              mainValue={dashboardBalances.vcNetContribution}
              percentageDifference={40}
              hideBalance={hideBalances}
            />
            <AccountCard
              headText={"Total Contribution"}
              mainValue={dashboardBalances.vcTotalContribution}
              percentageDifference={40}
              hideBalance={hideBalances}
            />
            <AccountCard
              headText={"Unit Price"}
              mainValue={dashboardBalances.vcUnitPrice}
              percentageDifference={40}
              hideBalance={hideBalances}
              notACurrency
            />
            <AccountCard
              headText={"Total Units"}
              mainValue={dashboardBalances.vcTotalUnits}
              percentageDifference={40}
              hideBalance={hideBalances}
              notACurrency
            />
          </div>
        )}
      </div>
    </div>
    </TimeOutActivityLayout>
  );
};
export default InactivityTimeoutHOC(Dashboard, 900000);
